angular.module("vgresiduos").directive("disposalPendenciesControl", function () {
	return {
		scope: true,
		controller: "DisposalPendenciesControlCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/destination/steps/disposalPendenciesControl/disposalPendenciesControl_template.html"
	};
});
